export default "__VITE_ASSET__BRSpOEoP__"